// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/offer.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { DateRange, FieldError, ListSort, Money, Ownership, Pagination, PaginationMeta, TagRef } from "./common_pb.js";
import { ConversionMapping, PayoutModel } from "./affiliate_network_pb.js";
import { StatsRow } from "./reporting_pb.js";
import { AttributionBasis } from "./analytics_pb.js";

/**
 * @generated from enum tracker.v1.ActionType
 */
export enum ActionType {
  /**
   * @generated from enum value: ACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTION_TYPE_LINK = 1;
   */
  LINK = 1,

  /**
   * @generated from enum value: ACTION_TYPE_REDIRECT = 2;
   */
  REDIRECT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ActionType)
proto3.util.setEnumType(ActionType, "tracker.v1.ActionType", [
  { no: 0, name: "ACTION_TYPE_UNSPECIFIED" },
  { no: 1, name: "ACTION_TYPE_LINK" },
  { no: 2, name: "ACTION_TYPE_REDIRECT" },
]);

/**
 * @generated from enum tracker.v1.OfferStatus
 */
export enum OfferStatus {
  /**
   * @generated from enum value: OFFER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: OFFER_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: OFFER_STATUS_PAUSED = 2;
   */
  PAUSED = 2,

  /**
   * @generated from enum value: OFFER_STATUS_CAPPED = 3;
   */
  CAPPED = 3,

  /**
   * @generated from enum value: OFFER_STATUS_ARCHIVED = 4;
   */
  ARCHIVED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(OfferStatus)
proto3.util.setEnumType(OfferStatus, "tracker.v1.OfferStatus", [
  { no: 0, name: "OFFER_STATUS_UNSPECIFIED" },
  { no: 1, name: "OFFER_STATUS_ACTIVE" },
  { no: 2, name: "OFFER_STATUS_PAUSED" },
  { no: 3, name: "OFFER_STATUS_CAPPED" },
  { no: 4, name: "OFFER_STATUS_ARCHIVED" },
]);

/**
 * The offer list's attention tiles — sets the server computes, never ids
 * a page carries.
 *
 * @generated from enum tracker.v1.OfferQuickView
 */
export enum OfferQuickView {
  /**
   * @generated from enum value: OFFER_QUICK_VIEW_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * GetOfferLibrary.capped_today.
   *
   * @generated from enum value: OFFER_QUICK_VIEW_CAPPED_TODAY = 1;
   */
  CAPPED_TODAY = 1,

  /**
   * GetOfferLibrary.without_leads_7d.
   *
   * @generated from enum value: OFFER_QUICK_VIEW_WITHOUT_LEADS_7D = 2;
   */
  WITHOUT_LEADS_7D = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(OfferQuickView)
proto3.util.setEnumType(OfferQuickView, "tracker.v1.OfferQuickView", [
  { no: 0, name: "OFFER_QUICK_VIEW_UNSPECIFIED" },
  { no: 1, name: "OFFER_QUICK_VIEW_CAPPED_TODAY" },
  { no: 2, name: "OFFER_QUICK_VIEW_WITHOUT_LEADS_7D" },
]);

/**
 * Offer is the generic, metadata-first traffic-tracker offer owned by an
 * AffiliateNetwork. It models ONLY what tracking needs — destination, payout,
 * caps, geo, and external ids. Commercial/product attributes (price, AR,
 * capacity, form_type, guarantees) live in vibe-catalog, not here.
 *
 * @generated from message tracker.v1.Offer
 */
export class Offer extends Message<Offer> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string network_id = 3;
   */
  networkId = "";

  /**
   * @generated from field: string name = 4;
   */
  name = "";

  /**
   * @generated from field: string group_id = 5;
   */
  groupId = "";

  /**
   * Action is the offer destination. Payload is OPTIONAL — a metadata-only
   * offer carries an empty payload and is simply not selected by the click
   * router; it still serves attribution, payout, and reporting.
   *
   * @generated from field: tracker.v1.ActionConfig action = 6;
   */
  action?: ActionConfig;

  /**
   * @generated from field: tracker.v1.PayoutConfig payout = 7;
   */
  payout?: PayoutConfig;

  /**
   * @generated from field: tracker.v1.CapsConfig caps = 8;
   */
  caps?: CapsConfig;

  /**
   * Country is the ISO-3166 alpha-2 geo facet (reporting + per-geo cap/payout).
   *
   * @generated from field: repeated string country = 9;
   */
  country: string[] = [];

  /**
   * CustomParams replaces Keitaro's fixed custom_param_1..15 — appended to the
   * lander/offer URL as {offer_param_KEY} macros by the click router.
   *
   * @generated from field: map<string, string> custom_params = 10;
   */
  customParams: { [key: string]: string } = {};

  /**
   * External identifiers for legacy/Keitaro import + inbound postback
   * resolution. external_offer_id is the per-workspace idempotency key.
   *
   * @generated from field: string external_offer_id = 11;
   */
  externalOfferId = "";

  /**
   * @generated from field: string external_campaign_id = 12;
   */
  externalCampaignId = "";

  /**
   * @generated from field: tracker.v1.OfferStatus status = 13;
   */
  status = OfferStatus.UNSPECIFIED;

  /**
   * @generated from field: string notes = 14;
   */
  notes = "";

  /**
   * @generated from field: repeated tracker.v1.TagRef tags = 15;
   */
  tags: TagRef[] = [];

  /**
   * @generated from field: tracker.v1.Ownership ownership = 16;
   */
  ownership?: Ownership;

  /**
   * @generated from field: string created_at = 17;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 18;
   */
  updatedAt = "";

  /**
   * Goal preset key ('generic', 'nutra', 'gambling'; empty = generic).
   *
   * @generated from field: string goal_preset = 19;
   */
  goalPreset = "";

  /**
   * The offer's own override of its network's mapping; empty = inherit.
   * Unset on UpdateOffer keeps the stored override (a client that does not
   * know the field never wipes it); set — even empty — replaces it.
   *
   * @generated from field: tracker.v1.ConversionMapping conversion_mapping = 21;
   */
  conversionMapping?: ConversionMapping;

  /**
   * The offer source that publishes this offer ("" = authored here).
   * Read-only: on a sourced offer name, network, payout, countries, status,
   * external ids and custom_params belong to the source (UpdateOffer refuses
   * them as SOURCE_OWNED, ArchiveOffer refuses the offer) — the editor shows
   * them locked.
   *
   * @generated from field: string source = 22;
   */
  source = "";

  constructor(data?: PartialMessage<Offer>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.Offer";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "action", kind: "message", T: ActionConfig },
    { no: 7, name: "payout", kind: "message", T: PayoutConfig },
    { no: 8, name: "caps", kind: "message", T: CapsConfig },
    { no: 9, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "custom_params", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 11, name: "external_offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "external_campaign_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "status", kind: "enum", T: proto3.getEnumType(OfferStatus) },
    { no: 14, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "tags", kind: "message", T: TagRef, repeated: true },
    { no: 16, name: "ownership", kind: "message", T: Ownership },
    { no: 17, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "goal_preset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "conversion_mapping", kind: "message", T: ConversionMapping },
    { no: 22, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Offer {
    return new Offer().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Offer {
    return new Offer().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Offer {
    return new Offer().fromJsonString(jsonString, options);
  }

  static equals(a: Offer | PlainMessage<Offer> | undefined, b: Offer | PlainMessage<Offer> | undefined): boolean {
    return proto3.util.equals(Offer, a, b);
  }
}

/**
 * @generated from message tracker.v1.ActionConfig
 */
export class ActionConfig extends Message<ActionConfig> {
  /**
   * @generated from field: tracker.v1.ActionType type = 1;
   */
  type = ActionType.UNSPECIFIED;

  /**
   * @generated from field: string payload = 2;
   */
  payload = "";

  /**
   * @generated from field: map<string, string> options = 3;
   */
  options: { [key: string]: string } = {};

  constructor(data?: PartialMessage<ActionConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ActionConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(ActionType) },
    { no: 2, name: "payload", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "options", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ActionConfig {
    return new ActionConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ActionConfig {
    return new ActionConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ActionConfig {
    return new ActionConfig().fromJsonString(jsonString, options);
  }

  static equals(a: ActionConfig | PlainMessage<ActionConfig> | undefined, b: ActionConfig | PlainMessage<ActionConfig> | undefined): boolean {
    return proto3.util.equals(ActionConfig, a, b);
  }
}

/**
 * PayoutRule is an optional per-geo payout override (Keitaro "payout per
 * country"). When the click country matches, it wins over the default payout.
 *
 * @generated from message tracker.v1.PayoutRule
 */
export class PayoutRule extends Message<PayoutRule> {
  /**
   * @generated from field: string country = 1;
   */
  country = "";

  /**
   * @generated from field: tracker.v1.PayoutModel model = 2;
   */
  model = PayoutModel.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.Money amount = 3;
   */
  amount?: Money;

  constructor(data?: PartialMessage<PayoutRule>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PayoutRule";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "model", kind: "enum", T: proto3.getEnumType(PayoutModel) },
    { no: 3, name: "amount", kind: "message", T: Money },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PayoutRule {
    return new PayoutRule().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PayoutRule {
    return new PayoutRule().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PayoutRule {
    return new PayoutRule().fromJsonString(jsonString, options);
  }

  static equals(a: PayoutRule | PlainMessage<PayoutRule> | undefined, b: PayoutRule | PlainMessage<PayoutRule> | undefined): boolean {
    return proto3.util.equals(PayoutRule, a, b);
  }
}

/**
 * @generated from message tracker.v1.PayoutConfig
 */
export class PayoutConfig extends Message<PayoutConfig> {
  /**
   * @generated from field: tracker.v1.PayoutModel model = 1;
   */
  model = PayoutModel.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.Money amount = 2;
   */
  amount?: Money;

  /**
   * @generated from field: repeated tracker.v1.PayoutRule rules = 3;
   */
  rules: PayoutRule[] = [];

  constructor(data?: PartialMessage<PayoutConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.PayoutConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "model", kind: "enum", T: proto3.getEnumType(PayoutModel) },
    { no: 2, name: "amount", kind: "message", T: Money },
    { no: 3, name: "rules", kind: "message", T: PayoutRule, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PayoutConfig {
    return new PayoutConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PayoutConfig {
    return new PayoutConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PayoutConfig {
    return new PayoutConfig().fromJsonString(jsonString, options);
  }

  static equals(a: PayoutConfig | PlainMessage<PayoutConfig> | undefined, b: PayoutConfig | PlainMessage<PayoutConfig> | undefined): boolean {
    return proto3.util.equals(PayoutConfig, a, b);
  }
}

/**
 * @generated from message tracker.v1.CapsConfig
 */
export class CapsConfig extends Message<CapsConfig> {
  /**
   * @generated from field: int32 daily_conversions = 1;
   */
  dailyConversions = 0;

  /**
   * @generated from field: int32 total_conversions = 2;
   */
  totalConversions = 0;

  /**
   * @generated from field: int32 click_daily = 3;
   */
  clickDaily = 0;

  /**
   * @generated from field: int32 click_total = 4;
   */
  clickTotal = 0;

  /**
   * @generated from field: string timezone = 5;
   */
  timezone = "";

  /**
   * @generated from field: string fallback_offer_id = 6;
   */
  fallbackOfferId = "";

  constructor(data?: PartialMessage<CapsConfig>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CapsConfig";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "daily_conversions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "total_conversions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "click_daily", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "click_total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "fallback_offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CapsConfig {
    return new CapsConfig().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CapsConfig {
    return new CapsConfig().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CapsConfig {
    return new CapsConfig().fromJsonString(jsonString, options);
  }

  static equals(a: CapsConfig | PlainMessage<CapsConfig> | undefined, b: CapsConfig | PlainMessage<CapsConfig> | undefined): boolean {
    return proto3.util.equals(CapsConfig, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListOffersRequest
 */
export class ListOffersRequest extends Message<ListOffersRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: string network_id = 2;
   */
  networkId = "";

  /**
   * @generated from field: repeated tracker.v1.OfferStatus statuses = 3;
   */
  statuses: OfferStatus[] = [];

  /**
   * @generated from field: string search = 5;
   */
  search = "";

  /**
   * @generated from field: repeated string tag_ids = 6;
   */
  tagIds: string[] = [];

  /**
   * @generated from field: string group_id = 7;
   */
  groupId = "";

  /**
   * Offers by their own id — a screen naming the offers it already shows.
   *
   * @generated from field: repeated string ids = 8;
   */
  ids: string[] = [];

  /**
   * name | status | created_at (default: created_at, newest first).
   *
   * @generated from field: tracker.v1.ListSort sort = 9;
   */
  sort?: ListSort;

  /**
   * Any of these countries (ISO-3166 alpha-2) — the «Страна» chip.
   *
   * @generated from field: repeated string countries = 10;
   */
  countries: string[] = [];

  /**
   * Any of these default payout models — the «Модель» chip.
   *
   * @generated from field: repeated tracker.v1.PayoutModel payout_models = 11;
   */
  payoutModels: PayoutModel[] = [];

  /**
   * Authored by these people (Keycloak subs). The caller's own offers are
   * `mine`, never his sub named here.
   *
   * @generated from field: repeated string owner_ids = 12;
   */
  ownerIds: string[] = [];

  /**
   * One of GetOfferLibrary's attention tiles, resolved here on the server
   * with no ceiling: the list's total is the tile's count (GetOfferLibrary
   * asked with the same owner_ids). ANDs with the rest of the filter (ids
   * included).
   *
   * @generated from field: tracker.v1.OfferQuickView quick_view = 13;
   */
  quickView = OfferQuickView.UNSPECIFIED;

  /**
   * «Мои» of the Top bar: only the offers of the person the call is made as
   * (the server's identity of the caller, under console's act-as the person
   * acted as). ANDed with the rest, owner_ids included.
   *
   * @generated from field: bool mine = 14;
   */
  mine = false;

  constructor(data?: PartialMessage<ListOffersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListOffersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "network_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "statuses", kind: "enum", T: proto3.getEnumType(OfferStatus), repeated: true },
    { no: 5, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tag_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "group_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "sort", kind: "message", T: ListSort },
    { no: 10, name: "countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "payout_models", kind: "enum", T: proto3.getEnumType(PayoutModel), repeated: true },
    { no: 12, name: "owner_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 13, name: "quick_view", kind: "enum", T: proto3.getEnumType(OfferQuickView) },
    { no: 14, name: "mine", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListOffersRequest {
    return new ListOffersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListOffersRequest {
    return new ListOffersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListOffersRequest {
    return new ListOffersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListOffersRequest | PlainMessage<ListOffersRequest> | undefined, b: ListOffersRequest | PlainMessage<ListOffersRequest> | undefined): boolean {
    return proto3.util.equals(ListOffersRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListOffersResponse
 */
export class ListOffersResponse extends Message<ListOffersResponse> {
  /**
   * @generated from field: repeated tracker.v1.Offer items = 1;
   */
  items: Offer[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListOffersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListOffersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: Offer, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListOffersResponse {
    return new ListOffersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListOffersResponse {
    return new ListOffersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListOffersResponse {
    return new ListOffersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListOffersResponse | PlainMessage<ListOffersResponse> | undefined, b: ListOffersResponse | PlainMessage<ListOffersResponse> | undefined): boolean {
    return proto3.util.equals(ListOffersResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetOfferRequest
 */
export class GetOfferRequest extends Message<GetOfferRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetOfferRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetOfferRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOfferRequest {
    return new GetOfferRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOfferRequest {
    return new GetOfferRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOfferRequest {
    return new GetOfferRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOfferRequest | PlainMessage<GetOfferRequest> | undefined, b: GetOfferRequest | PlainMessage<GetOfferRequest> | undefined): boolean {
    return proto3.util.equals(GetOfferRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetOfferResponse
 */
export class GetOfferResponse extends Message<GetOfferResponse> {
  /**
   * @generated from field: tracker.v1.Offer offer = 1;
   */
  offer?: Offer;

  constructor(data?: PartialMessage<GetOfferResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetOfferResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offer", kind: "message", T: Offer },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOfferResponse {
    return new GetOfferResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOfferResponse {
    return new GetOfferResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOfferResponse {
    return new GetOfferResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOfferResponse | PlainMessage<GetOfferResponse> | undefined, b: GetOfferResponse | PlainMessage<GetOfferResponse> | undefined): boolean {
    return proto3.util.equals(GetOfferResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateOfferRequest
 */
export class CreateOfferRequest extends Message<CreateOfferRequest> {
  /**
   * @generated from field: tracker.v1.Offer offer = 1;
   */
  offer?: Offer;

  constructor(data?: PartialMessage<CreateOfferRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateOfferRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offer", kind: "message", T: Offer },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateOfferRequest {
    return new CreateOfferRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateOfferRequest {
    return new CreateOfferRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateOfferRequest {
    return new CreateOfferRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateOfferRequest | PlainMessage<CreateOfferRequest> | undefined, b: CreateOfferRequest | PlainMessage<CreateOfferRequest> | undefined): boolean {
    return proto3.util.equals(CreateOfferRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateOfferResponse
 */
export class CreateOfferResponse extends Message<CreateOfferResponse> {
  /**
   * @generated from field: tracker.v1.Offer offer = 1;
   */
  offer?: Offer;

  constructor(data?: PartialMessage<CreateOfferResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateOfferResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offer", kind: "message", T: Offer },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateOfferResponse {
    return new CreateOfferResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateOfferResponse {
    return new CreateOfferResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateOfferResponse {
    return new CreateOfferResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateOfferResponse | PlainMessage<CreateOfferResponse> | undefined, b: CreateOfferResponse | PlainMessage<CreateOfferResponse> | undefined): boolean {
    return proto3.util.equals(CreateOfferResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateOfferRequest
 */
export class UpdateOfferRequest extends Message<UpdateOfferRequest> {
  /**
   * @generated from field: tracker.v1.Offer offer = 1;
   */
  offer?: Offer;

  constructor(data?: PartialMessage<UpdateOfferRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateOfferRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offer", kind: "message", T: Offer },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOfferRequest {
    return new UpdateOfferRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOfferRequest {
    return new UpdateOfferRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOfferRequest {
    return new UpdateOfferRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOfferRequest | PlainMessage<UpdateOfferRequest> | undefined, b: UpdateOfferRequest | PlainMessage<UpdateOfferRequest> | undefined): boolean {
    return proto3.util.equals(UpdateOfferRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateOfferResponse
 */
export class UpdateOfferResponse extends Message<UpdateOfferResponse> {
  /**
   * @generated from field: tracker.v1.Offer offer = 1;
   */
  offer?: Offer;

  constructor(data?: PartialMessage<UpdateOfferResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateOfferResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offer", kind: "message", T: Offer },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateOfferResponse {
    return new UpdateOfferResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateOfferResponse {
    return new UpdateOfferResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateOfferResponse {
    return new UpdateOfferResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateOfferResponse | PlainMessage<UpdateOfferResponse> | undefined, b: UpdateOfferResponse | PlainMessage<UpdateOfferResponse> | undefined): boolean {
    return proto3.util.equals(UpdateOfferResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveOfferRequest
 */
export class ArchiveOfferRequest extends Message<ArchiveOfferRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ArchiveOfferRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveOfferRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveOfferRequest {
    return new ArchiveOfferRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveOfferRequest {
    return new ArchiveOfferRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveOfferRequest {
    return new ArchiveOfferRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveOfferRequest | PlainMessage<ArchiveOfferRequest> | undefined, b: ArchiveOfferRequest | PlainMessage<ArchiveOfferRequest> | undefined): boolean {
    return proto3.util.equals(ArchiveOfferRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveOfferResponse
 */
export class ArchiveOfferResponse extends Message<ArchiveOfferResponse> {
  constructor(data?: PartialMessage<ArchiveOfferResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveOfferResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveOfferResponse {
    return new ArchiveOfferResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveOfferResponse {
    return new ArchiveOfferResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveOfferResponse {
    return new ArchiveOfferResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveOfferResponse | PlainMessage<ArchiveOfferResponse> | undefined, b: ArchiveOfferResponse | PlainMessage<ArchiveOfferResponse> | undefined): boolean {
    return proto3.util.equals(ArchiveOfferResponse, a, b);
  }
}

/**
 * OfferUsage counts the active (non-archived) flows + campaigns that
 * reference the offer. Backs the "Used in N flows" picker badge.
 *
 * @generated from message tracker.v1.OfferUsage
 */
export class OfferUsage extends Message<OfferUsage> {
  /**
   * @generated from field: int32 flow_count = 1;
   */
  flowCount = 0;

  /**
   * @generated from field: int32 campaign_count = 2;
   */
  campaignCount = 0;

  /**
   * @generated from field: repeated string flow_ids = 3;
   */
  flowIds: string[] = [];

  constructor(data?: PartialMessage<OfferUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.OfferUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "campaign_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "flow_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OfferUsage {
    return new OfferUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OfferUsage {
    return new OfferUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OfferUsage {
    return new OfferUsage().fromJsonString(jsonString, options);
  }

  static equals(a: OfferUsage | PlainMessage<OfferUsage> | undefined, b: OfferUsage | PlainMessage<OfferUsage> | undefined): boolean {
    return proto3.util.equals(OfferUsage, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetOfferUsageRequest
 */
export class GetOfferUsageRequest extends Message<GetOfferUsageRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetOfferUsageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetOfferUsageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOfferUsageRequest {
    return new GetOfferUsageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOfferUsageRequest {
    return new GetOfferUsageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOfferUsageRequest {
    return new GetOfferUsageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOfferUsageRequest | PlainMessage<GetOfferUsageRequest> | undefined, b: GetOfferUsageRequest | PlainMessage<GetOfferUsageRequest> | undefined): boolean {
    return proto3.util.equals(GetOfferUsageRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetOfferUsageResponse
 */
export class GetOfferUsageResponse extends Message<GetOfferUsageResponse> {
  /**
   * @generated from field: tracker.v1.OfferUsage usage = 1;
   */
  usage?: OfferUsage;

  constructor(data?: PartialMessage<GetOfferUsageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetOfferUsageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "usage", kind: "message", T: OfferUsage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOfferUsageResponse {
    return new GetOfferUsageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOfferUsageResponse {
    return new GetOfferUsageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOfferUsageResponse {
    return new GetOfferUsageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOfferUsageResponse | PlainMessage<GetOfferUsageResponse> | undefined, b: GetOfferUsageResponse | PlainMessage<GetOfferUsageResponse> | undefined): boolean {
    return proto3.util.equals(GetOfferUsageResponse, a, b);
  }
}

/**
 * ValidateOffer runs the save-time checks without saving and answers every
 * problem at once, each on its field — the editor paints them all (board
 * OfferEditorErrors). Create/Update run the same checks and refuse with
 * InvalidArgument: the first problem rides in X-Field / X-Field-Code, and
 * every problem rides as a tracker.v1.FieldError error detail.
 *
 * Paths: name, network_id, country[i], action.payload, payout.amount,
 * payout.amount.currency, payout.rules[i].country, payout.rules[i].amount,
 * caps.daily_conversions, caps.total_conversions, caps.click_daily,
 * caps.click_total, caps.timezone, caps.fallback_offer_id,
 * custom_params[KEY], goal_preset, conversion_mapping.statuses[i].word,
 * conversion_mapping.goals[i].goal_key, conversion_mapping.default_goal.
 *
 * The offer is a draft: Offer's own wire rules (a name of at least one
 * character) are not enforced on it here, or an unnamed draft would get one
 * InvalidArgument instead of its list — Check reports a missing name as
 * NAME_REQUIRED beside the empty payout and the rest.
 *
 * @generated from message tracker.v1.ValidateOfferRequest
 */
export class ValidateOfferRequest extends Message<ValidateOfferRequest> {
  /**
   * @generated from field: tracker.v1.Offer offer = 1;
   */
  offer?: Offer;

  constructor(data?: PartialMessage<ValidateOfferRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ValidateOfferRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offer", kind: "message", T: Offer },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateOfferRequest {
    return new ValidateOfferRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateOfferRequest {
    return new ValidateOfferRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateOfferRequest {
    return new ValidateOfferRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateOfferRequest | PlainMessage<ValidateOfferRequest> | undefined, b: ValidateOfferRequest | PlainMessage<ValidateOfferRequest> | undefined): boolean {
    return proto3.util.equals(ValidateOfferRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ValidateOfferResponse
 */
export class ValidateOfferResponse extends Message<ValidateOfferResponse> {
  /**
   * @generated from field: repeated tracker.v1.FieldError errors = 1;
   */
  errors: FieldError[] = [];

  constructor(data?: PartialMessage<ValidateOfferResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ValidateOfferResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: FieldError, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateOfferResponse {
    return new ValidateOfferResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateOfferResponse {
    return new ValidateOfferResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateOfferResponse {
    return new ValidateOfferResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateOfferResponse | PlainMessage<ValidateOfferResponse> | undefined, b: ValidateOfferResponse | PlainMessage<ValidateOfferResponse> | undefined): boolean {
    return proto3.util.equals(ValidateOfferResponse, a, b);
  }
}

/**
 * OfferCapUsage is how much of its caps an offer has used. A lead is the
 * reporting registry's «Лиды» (every status), counted on the day the lead
 * arrived in the cap's own timezone. Limits of 0 mean «без лимита» and their
 * used counts are not computed (0).
 *
 * @generated from message tracker.v1.OfferCapUsage
 */
export class OfferCapUsage extends Message<OfferCapUsage> {
  /**
   * The day the daily counts are for (YYYY-MM-DD in timezone).
   *
   * @generated from field: string day = 1;
   */
  day = "";

  /**
   * @generated from field: string timezone = 2;
   */
  timezone = "";

  /**
   * @generated from field: int64 daily_limit = 3;
   */
  dailyLimit = protoInt64.zero;

  /**
   * @generated from field: int64 daily_used = 4;
   */
  dailyUsed = protoInt64.zero;

  /**
   * @generated from field: int64 total_limit = 5;
   */
  totalLimit = protoInt64.zero;

  /**
   * Leads since the offer was created (at most the last 366 days).
   *
   * @generated from field: int64 total_used = 6;
   */
  totalUsed = protoInt64.zero;

  /**
   * @generated from field: int64 click_daily_limit = 7;
   */
  clickDailyLimit = protoInt64.zero;

  /**
   * Clicks (people, the registry's «Клики») sent to the offer today.
   *
   * @generated from field: int64 click_daily_used = 8;
   */
  clickDailyUsed = protoInt64.zero;

  /**
   * A limit is used up. The number only: the edge does not enforce offer
   * caps yet, so traffic keeps flowing — fallback_offer_id is where the
   * author wants it sent.
   *
   * @generated from field: bool reached = 9;
   */
  reached = false;

  /**
   * @generated from field: string fallback_offer_id = 10;
   */
  fallbackOfferId = "";

  constructor(data?: PartialMessage<OfferCapUsage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.OfferCapUsage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "day", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "daily_limit", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "daily_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "total_limit", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "total_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "click_daily_limit", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "click_daily_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "reached", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "fallback_offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OfferCapUsage {
    return new OfferCapUsage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OfferCapUsage {
    return new OfferCapUsage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OfferCapUsage {
    return new OfferCapUsage().fromJsonString(jsonString, options);
  }

  static equals(a: OfferCapUsage | PlainMessage<OfferCapUsage> | undefined, b: OfferCapUsage | PlainMessage<OfferCapUsage> | undefined): boolean {
    return proto3.util.equals(OfferCapUsage, a, b);
  }
}

/**
 * OfferNumbers is one offer's row of the list: the report's numbers for the
 * period, its campaigns, its cap.
 *
 * @generated from message tracker.v1.OfferNumbers
 */
export class OfferNumbers extends Message<OfferNumbers> {
  /**
   * @generated from field: string offer_id = 1;
   */
  offerId = "";

  /**
   * The report engine's row for dimension «offer» — the same numbers
   * GetBreakdownDrilldown answers for that offer and period.
   *
   * @generated from field: tracker.v1.StatsRow stats = 2;
   */
  stats?: StatsRow;

  /**
   * The same over compare_range; unset without one.
   *
   * @generated from field: tracker.v1.StatsRow compare = 3;
   */
  compare?: StatsRow;

  /**
   * Live (not archived) campaigns whose flow can route to the offer.
   *
   * @generated from field: int32 campaign_count = 4;
   */
  campaignCount = 0;

  /**
   * @generated from field: tracker.v1.OfferCapUsage cap = 5;
   */
  cap?: OfferCapUsage;

  constructor(data?: PartialMessage<OfferNumbers>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.OfferNumbers";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offer_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stats", kind: "message", T: StatsRow },
    { no: 3, name: "compare", kind: "message", T: StatsRow },
    { no: 4, name: "campaign_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "cap", kind: "message", T: OfferCapUsage },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OfferNumbers {
    return new OfferNumbers().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OfferNumbers {
    return new OfferNumbers().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OfferNumbers {
    return new OfferNumbers().fromJsonString(jsonString, options);
  }

  static equals(a: OfferNumbers | PlainMessage<OfferNumbers> | undefined, b: OfferNumbers | PlainMessage<OfferNumbers> | undefined): boolean {
    return proto3.util.equals(OfferNumbers, a, b);
  }
}

/**
 * ListOfferNumbers answers the numbers of the offers on screen over the app's
 * one period (the top bar's from/to — the campaign list's), from the report
 * engine: metrics are the reporting registry's, and `totals` is the engine's
 * «Итого» over exactly these offers (people counted once, never a sum of rows).
 * An offer without traffic has an empty stats row, never an absent item.
 *
 * @generated from message tracker.v1.ListOfferNumbersRequest
 */
export class ListOfferNumbersRequest extends Message<ListOfferNumbersRequest> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange date_range = 2;
   */
  dateRange?: DateRange;

  /**
   * @generated from field: tracker.v1.AttributionBasis attribution_basis = 3;
   */
  attributionBasis = AttributionBasis.UNSPECIFIED;

  /**
   * Restricts the returned StatsRow values; empty = all metrics.
   *
   * @generated from field: repeated string metric_keys = 4;
   */
  metricKeys: string[] = [];

  /**
   * @generated from field: tracker.v1.DateRange compare_range = 5;
   */
  compareRange?: DateRange;

  constructor(data?: PartialMessage<ListOfferNumbersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListOfferNumbersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "date_range", kind: "message", T: DateRange },
    { no: 3, name: "attribution_basis", kind: "enum", T: proto3.getEnumType(AttributionBasis) },
    { no: 4, name: "metric_keys", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "compare_range", kind: "message", T: DateRange },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListOfferNumbersRequest {
    return new ListOfferNumbersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListOfferNumbersRequest {
    return new ListOfferNumbersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListOfferNumbersRequest {
    return new ListOfferNumbersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListOfferNumbersRequest | PlainMessage<ListOfferNumbersRequest> | undefined, b: ListOfferNumbersRequest | PlainMessage<ListOfferNumbersRequest> | undefined): boolean {
    return proto3.util.equals(ListOfferNumbersRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListOfferNumbersResponse
 */
export class ListOfferNumbersResponse extends Message<ListOfferNumbersResponse> {
  /**
   * @generated from field: repeated tracker.v1.OfferNumbers items = 1;
   */
  items: OfferNumbers[] = [];

  /**
   * @generated from field: tracker.v1.StatsRow totals = 2;
   */
  totals?: StatsRow;

  /**
   * @generated from field: tracker.v1.StatsRow compare_totals = 3;
   */
  compareTotals?: StatsRow;

  constructor(data?: PartialMessage<ListOfferNumbersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListOfferNumbersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: OfferNumbers, repeated: true },
    { no: 2, name: "totals", kind: "message", T: StatsRow },
    { no: 3, name: "compare_totals", kind: "message", T: StatsRow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListOfferNumbersResponse {
    return new ListOfferNumbersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListOfferNumbersResponse {
    return new ListOfferNumbersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListOfferNumbersResponse {
    return new ListOfferNumbersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListOfferNumbersResponse | PlainMessage<ListOfferNumbersResponse> | undefined, b: ListOfferNumbersResponse | PlainMessage<ListOfferNumbersResponse> | undefined): boolean {
    return proto3.util.equals(ListOfferNumbersResponse, a, b);
  }
}

/**
 * GetOfferLibrary is the list's tiles: counts over EVERY offer of the
 * workspace (or of owner_ids), never over the page on screen. The two
 * attention tiles open as ListOffers quick_view, which resolves the same set
 * on the server.
 *
 * @generated from message tracker.v1.GetOfferLibraryRequest
 */
export class GetOfferLibraryRequest extends Message<GetOfferLibraryRequest> {
  /**
   * The top bar's «Мои»: every count is over the caller's own offers only —
   * the `mine` the list sends with ListOffers, so a tab's number is the
   * table's total. False: the whole workspace. The `mine` tile always counts
   * the caller's own.
   *
   * @generated from field: bool mine = 3;
   */
  mine = false;

  constructor(data?: PartialMessage<GetOfferLibraryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetOfferLibraryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 3, name: "mine", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOfferLibraryRequest {
    return new GetOfferLibraryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOfferLibraryRequest {
    return new GetOfferLibraryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOfferLibraryRequest {
    return new GetOfferLibraryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOfferLibraryRequest | PlainMessage<GetOfferLibraryRequest> | undefined, b: GetOfferLibraryRequest | PlainMessage<GetOfferLibraryRequest> | undefined): boolean {
    return proto3.util.equals(GetOfferLibraryRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetOfferLibraryResponse
 */
export class GetOfferLibraryResponse extends Message<GetOfferLibraryResponse> {
  /**
   * Not archived, status ACTIVE.
   *
   * @generated from field: int64 active = 1;
   */
  active = protoInt64.zero;

  /**
   * Active offers whose daily lead cap is used up today (OfferCapUsage.reached).
   *
   * @generated from field: int64 capped_today = 2;
   */
  cappedToday = protoInt64.zero;

  /**
   * Active offers with no lead in the last 7 days (workspace timezone).
   *
   * @generated from field: int64 without_leads_7d = 4;
   */
  withoutLeads7d = protoInt64.zero;

  /**
   * @generated from field: int64 mine = 6;
   */
  mine = protoInt64.zero;

  /**
   * @generated from field: int64 archived = 7;
   */
  archived = protoInt64.zero;

  constructor(data?: PartialMessage<GetOfferLibraryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetOfferLibraryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "active", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "capped_today", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "without_leads_7d", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "mine", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "archived", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOfferLibraryResponse {
    return new GetOfferLibraryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOfferLibraryResponse {
    return new GetOfferLibraryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOfferLibraryResponse {
    return new GetOfferLibraryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOfferLibraryResponse | PlainMessage<GetOfferLibraryResponse> | undefined, b: GetOfferLibraryResponse | PlainMessage<GetOfferLibraryResponse> | undefined): boolean {
    return proto3.util.equals(GetOfferLibraryResponse, a, b);
  }
}

/**
 * CheckOfferLink opens the partner link the way a click would — every
 * {macro} filled with a probe value — and reports what came back without
 * counting anything: no click, no conversion, nothing journaled. Redirects are
 * followed (at most 5) only to name where the link lands. Addresses that
 * resolve to private, loopback or link-local networks are refused.
 *
 * @generated from message tracker.v1.CheckOfferLinkRequest
 */
export class CheckOfferLinkRequest extends Message<CheckOfferLinkRequest> {
  /**
   * The offer's action.payload as typed, macros and all.
   *
   * @generated from field: string url = 1;
   */
  url = "";

  constructor(data?: PartialMessage<CheckOfferLinkRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CheckOfferLinkRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckOfferLinkRequest {
    return new CheckOfferLinkRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckOfferLinkRequest {
    return new CheckOfferLinkRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckOfferLinkRequest {
    return new CheckOfferLinkRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckOfferLinkRequest | PlainMessage<CheckOfferLinkRequest> | undefined, b: CheckOfferLinkRequest | PlainMessage<CheckOfferLinkRequest> | undefined): boolean {
    return proto3.util.equals(CheckOfferLinkRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CheckOfferLinkResponse
 */
export class CheckOfferLinkResponse extends Message<CheckOfferLinkResponse> {
  /**
   * The first answer's HTTP status (302 for a partner redirect); 0 when the
   * link could not be opened at all (error says why).
   *
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * Redirects followed before the last answer.
   *
   * @generated from field: int32 redirects = 2;
   */
  redirects = 0;

  /**
   * Host of the last address reached.
   *
   * @generated from field: string final_host = 3;
   */
  finalHost = "";

  /**
   * Status of the last answer.
   *
   * @generated from field: int32 final_status = 4;
   */
  finalStatus = 0;

  /**
   * @generated from field: int64 elapsed_ms = 5;
   */
  elapsedMs = protoInt64.zero;

  /**
   * The template carries {clickid} (or another click-id macro) — without it
   * the partner's postback has no click to name.
   *
   * @generated from field: bool has_click_macro = 6;
   */
  hasClickMacro = false;

  /**
   * The macros found in the template, in order.
   *
   * @generated from field: repeated string macros = 7;
   */
  macros: string[] = [];

  /**
   * Why the link could not be opened: dns | timeout | tls | refused | blocked_address | bad_url | http.
   *
   * @generated from field: string error = 8;
   */
  error = "";

  /**
   * RFC3339
   *
   * @generated from field: string checked_at = 9;
   */
  checkedAt = "";

  constructor(data?: PartialMessage<CheckOfferLinkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CheckOfferLinkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "redirects", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "final_host", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "final_status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "elapsed_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "has_click_macro", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "macros", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "checked_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckOfferLinkResponse {
    return new CheckOfferLinkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckOfferLinkResponse {
    return new CheckOfferLinkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckOfferLinkResponse {
    return new CheckOfferLinkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckOfferLinkResponse | PlainMessage<CheckOfferLinkResponse> | undefined, b: CheckOfferLinkResponse | PlainMessage<CheckOfferLinkResponse> | undefined): boolean {
    return proto3.util.equals(CheckOfferLinkResponse, a, b);
  }
}

